var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import { observer } from 'mobx-react';
import { Wrapper, Lists } from './components';
import { ListBoardListV2 } from './list';
import { RotateLoader } from '../loaders/rotate';
import styled from 'styled-components';
import { BottomControlBtn } from './bottomControlBtns';
import { ChangeStatusModalBoard } from './modals/changeStatusModal';
import { OtherOptionsBoardModal } from './modals/otherOptionsModal';
const BottomControlWrapper = styled.div `
  width: 100vw;
  height: 76px;
  background: #fefefe;
  position: fixed;
  bottom: 0;
  left: 0;
  text-align: center;
`;
const BottomBtns = styled.div `
  width: 80%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
`;
const LeftBottomBtns = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const controlBtns = [
    {
        id: '1',
        text: 'Change status',
    },
    {
        id: '2',
        text: 'Other options',
    }
];
let ListBoardV2 = class ListBoardV2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showBottomBar: false,
            activeBottomBtnId: '',
            selectedOrders: [],
            listOrderColumn: [],
            ordersMoving: []
        };
    }
    componentDidMount() {
        this.props.fetch();
    }
    setSelectedOrders = (value) => {
        this.setState({
            selectedOrders: value,
        });
    };
    render() {
        const { data, columns, renderIcon, renderRow, renderRowDropdown, renderBottom, handleUpdateStatus, handleDeleteOrders, serviceChangeStatusFail } = this.props;
        const { error, loading } = data;
        if (error) {
            return React.createElement("p", { className: "error-text" }, "Something went wrong, refresh the page and try again");
        }
        if (loading) {
            return React.createElement(RotateLoader, { size: 4, style: { marginTop: '10px' } });
        }
        const { showBottomBar, activeBottomBtnId } = this.state;
        const toggleBottomBar = (value) => {
            this.setState({ showBottomBar: value });
        };
        const closeBar = () => {
            this.setState({ showBottomBar: false });
        };
        const handleBtnSelect = (value) => {
            this.setState({ activeBottomBtnId: value });
        };
        const setStatus = (value) => {
            this.setState({ listOrderColumn: value });
        };
        const handleUpdateStatusOrders = (status) => {
            const orderChangesStatus = this.state.ordersMoving.filter((item) => this.state.selectedOrders.includes(item._id));
            if (status === 'on_route' && Array.isArray(orderChangesStatus) && orderChangesStatus.length > 0) {
                const onRouteOrder = orderChangesStatus.filter((item) => item.config.service === 'delivery');
                const nonOnRouteOrder = orderChangesStatus.filter((item) => item.config.service !== 'delivery');
                const uniqueNonDeliveryServices = [...new Set(nonOnRouteOrder.map((item) => item.config.service))];
                if (uniqueNonDeliveryServices.length > 0 && serviceChangeStatusFail) {
                    serviceChangeStatusFail(uniqueNonDeliveryServices);
                }
                const onRouteOrderId = onRouteOrder.map((item) => item._id);
                handleUpdateStatus(onRouteOrderId, status);
            }
            else {
                handleUpdateStatus(this.state.selectedOrders, status);
            }
            this.setState({
                activeBottomBtnId: '',
                showBottomBar: false
            });
        };
        const handleDelete = () => {
            const { selectedOrders } = this.state;
            if (handleDeleteOrders) {
                this.setState({ activeBottomBtnId: '' });
                handleDeleteOrders(selectedOrders);
            }
        };
        const tempItems = (data && data.lists && Array.isArray(data.lists) && data.lists[this.state.listOrderColumn].items) || [];
        const allIds = tempItems.map((item) => item._id);
        const isAllSelected = allIds.every(id => this.state.selectedOrders.includes(id));
        return (React.createElement(React.Fragment, null,
            React.createElement(Wrapper, null, columns.map((column, i) => {
                if (column.lists.length === 1 && column.lists[0].hide) {
                    return null;
                }
                return (React.createElement(Lists, { key: i }, column.lists.map((list, k) => {
                    return (React.createElement(ListBoardListV2, { key: k, data: data, list: list, renderIcon: renderIcon, renderRow: renderRow, renderRowDropdown: renderRowDropdown, renderBottom: renderBottom, showBottomBar: showBottomBar, toggleBottomBar: toggleBottomBar, selectedOrders: this.state.selectedOrders, setSelectedOrders: this.setSelectedOrders, setStatus: setStatus, columnSelecting: (orders) => this.setState({ ordersMoving: orders }) }));
                })));
            })),
            showBottomBar && (React.createElement(BottomControlWrapper, null,
                React.createElement(BottomBtns, null,
                    React.createElement(LeftBottomBtns, null,
                        controlBtns.map(item => (React.createElement(BottomControlBtn, { key: item.id, highlighted: item.id === '3', active: activeBottomBtnId === item.id, onClick: () => handleBtnSelect(item.id) }, item.text))),
                        !isAllSelected ? React.createElement(BottomControlBtn, { onClick: () => this.setSelectedOrders(allIds), highlighted: true, style: { width: '110px', display: 'flex', justifyContent: 'center' } }, "Select All")
                            : React.createElement(BottomControlBtn, { onClick: () => this.setSelectedOrders([]), highlighted: true, style: { width: '110px', display: 'flex', justifyContent: 'center' } }, "Deselect All")),
                    React.createElement("div", null,
                        React.createElement(BottomControlBtn, { onClick: closeBar, cancelBtn: true }, "Cancel"))))),
            React.createElement(ChangeStatusModalBoard, { changeStatusActive: activeBottomBtnId === '1', setChangeStatusActive: () => { this.setState({ activeBottomBtnId: '' }); }, onChangeStatusOrder: handleUpdateStatusOrders }),
            React.createElement(OtherOptionsBoardModal, { isOpen: activeBottomBtnId === '2', handleClose: () => { this.setState({ activeBottomBtnId: '' }); }, handleDeleteOrders: handleDelete })));
    }
};
ListBoardV2 = __decorate([
    observer
], ListBoardV2);
export { ListBoardV2 };
//# sourceMappingURL=index.js.map